import overrideUtil from './overrideUtil.js';

import legoAccordion from './extend/legoAccordion';
import legoAccordionItem from './extend/legoAccordionItem';
// import legoAddListTable from './wrapping/legoAddListTable';
import legoTreeTable from './extend/legoTreeTable';
import legoChipExtend from './extend/legoChipExtend';
import legoModalExtend from './extend/legoModalExtend';
import legoModalExtendV2 from './extend/legoModalExtendV2';
import legoPagingTable from './wrapping/legoPagingTable';
// import legoPagingTableExpand from './wrapping/legoPagingTableExpand';
import legoPaginationExtend from './extend/legoPaginationExtend';
import legoPaginationExtendV2 from './extend/legoPaginationExtendV2';
import legoTableExtend from './extend/legoTableExtend';
import legoTableExpand from './extend/legoTableExpand';
import legoCheckboxExtend from './extend/legoCheckboxExtend';
import legoCheckboxWrapperExtend from './extend/legoCheckboxWrapperExtend';
import legoRadioExtend from './extend/legoRadioExtend';
import legoRadioWrapperExtend from './extend/legoRadioWrapperExtend';
import legoDropdownExtend from './extend/legoDropdownExtend';
import legoDropdownSearch from './extend/legoDropdownSearch';
import legoMultiDropdown from './extend/legoMultiDropdown';
import legoDropHolderExtend from './extend/legoDropHolderExtend';
import legoDropHolderItemIconExtend from './extend/legoDropHolderItemIconExtend';
import legoDropHolderStaticMethodExtend from './extend/legoDropHolderStaticMethodExtend';
import legoButtonExtend from './extend/legoButtonExtend';
import legoIconButtonExtend from './extend/legoIconButtonExtend';
import legoSegmentButtonExtend from './extend/legoSegmentButtonExtend';
import legoSegmentWrapperExtend from './extend/legoSegmentWrapperExtend';
import legoTextFieldExtend from './extend/legoTextFieldExtend';
import legoDatePickerExtend from './extend/legoDatePickerExtend';
// //import legoDatetimePeriodPickerExtend from './extend/legoDatetimePeriodPickerExtend/legoDatetimePeriodPickerExtend.vue';
import legoTabBoxExtend from './extend/legoTabBoxExtend';
import legoTooltipExtend from './extend/legoTooltipExtend';
import legoTooltipExtendV2 from './extend/legoTooltipExtendV2';
import legoPopover from './extend/legoPopover'
import legoListExtend from './extend/legoListExtend';
import legoIconExtend from './extend/legoIconExtend/legoIconExtend';
import legoSwitchExtend from './extend/legoSwitchExtend';
import legoStepBoxExtend from './extend/legoStepBoxExtend';
import legoDashboardExtend from './extend/legoDashboardExtend';
import legoTreeExtend from './extend/legoTreeExtend';
import legoTreePolicy from './extend/legoTreePolicy';
import legoToastExtend from './extend/legoToastExtend';
// import legoPagingTableCustom from './wrapping/legoPagingTableCustom';
import legoTableCustom from './extend/legoTableCustom';
import legoDropdownCheckExtend from './extend/legoDropdownCheckExtend';

export default function (Vue) {
  let util = new overrideUtil(Vue);

  util.extend('lego-core-icon', legoIconExtend, 'lego-icon');
  util.extend('lego-core-radio-wrapper', legoRadioWrapperExtend, 'lego-radio-wrapper');
  util.extend('lego-core-radio', legoRadioExtend, 'lego-radio');
  util.extend('lego-core-checkbox-wrapper', legoCheckboxWrapperExtend, 'lego-checkbox-wrapper');
  util.extend('lego-core-checkbox', legoCheckboxExtend, 'lego-checkbox');
  util.extend('lego-core-button', legoButtonExtend, 'lego-button');
  util.extend('lego-core-icon-button', legoIconButtonExtend, 'lego-icon-button');
  util.extend('lego-core-segment-button', legoSegmentButtonExtend, 'lego-segment-button');
  util.extend('lego-core-segment-wrapper', legoSegmentWrapperExtend, 'lego-segment-wrapper');
  util.extend('lego-core-chip', legoChipExtend, 'lego-chip');
  util.extend('lego-core-text-field', legoTextFieldExtend, 'lego-text-field');
  util.extend('lego-core-tooltip', legoTooltipExtend, 'lego-tooltip');
  util.extend('lego-tooltip', legoTooltipExtendV2, 'lego-tooltip-extend-v-2');
  util.extend('lego-tooltip', legoPopover, 'lego-popover');
  util.extend('lego-core-switch', legoSwitchExtend, 'lego-switch');
  util.extend('lego-core-pagination', legoPaginationExtend, 'lego-pagination');
  util.extend('lego-core-pagination', legoPaginationExtendV2, 'lego-pagination-v2');
  util.extend('lego-core-dropdown', legoDropdownExtend, 'lego-dropdown');
  util.extend('lego-core-dropdown', legoDropdownExtend, 'lego-dropdown-extend');
  util.extend('lego-dropdown', legoDropdownSearch, 'lego-dropdown-search');
  util.extend('lego-dropdown-extend', legoMultiDropdown, 'lego-multi-dropdown');
  util.extend('lego-core-drop-holder', legoDropHolderExtend, 'lego-drop-holder');
  util.extend('lego-drop-holder', legoDropHolderItemIconExtend, 'lego-drop-holder-item-icon');
  util.extend(
    'lego-drop-holder',
    legoDropHolderStaticMethodExtend,
    'lego-drop-holder-static-method'
  );
  util.extend('lego-core-date-picker', legoDatePickerExtend, 'lego-date-picker');
  // //util.extend('lego-date-time-period-picker', legoDatetimePeriodPickerExtend);
  util.extend('lego-core-tab-box', legoTabBoxExtend, 'lego-tab-box');
  util.extend('lego-core-modal', legoModalExtend, 'lego-modal');
  util.extend('lego-modal', legoModalExtendV2, 'lego-modal-extend-v2');
  util.extend('lego-core-list', legoAccordion, 'lego-accordion');
  util.extend('lego-list-item', legoAccordionItem, 'lego-accordion-item');
  util.extend('lego-core-list', legoListExtend, 'lego-list');
  util.extend('lego-core-step-box', legoStepBoxExtend, 'lego-step-box');
  util.extend('lego-core-dashboard', legoDashboardExtend, 'lego-dashboard');
  util.extend('lego-core-table', legoTableExtend, 'lego-table');
  util.extend('lego-core-table', legoTableExtend, 'lego-table-extend');
  util.extend('lego-table', legoTableExpand, 'lego-table-expand');
  util.extend('lego-table-extend', legoTreeTable, 'lego-tree-table');
  // util.wrapping('lego-table', legoAddListTable, 'lego-add-list-table', 'l-table');
  util.wrapping('lego-table', legoPagingTable, 'lego-paging-table', 'l-table');
  // util.wrapping('lego-table', legoPagingTableExpand, 'lego-paging-table-expand', 'l-table');
  util.extend('lego-core-tree', legoTreeExtend, 'lego-tree');
  // util.extend('lego-tree', legoTreeExtend, 'lego-tree-extend');
  util.extend('lego-tree', legoTreePolicy, 'lego-tree-policy');
  util.extend('lego-core-toast', legoToastExtend, 'lego-toast');
  util.extend('lego-table', legoTableCustom, 'lego-table-custom');
  // util.wrapping('lego-table', legoPagingTableCustom, 'lego-paging-table-custom', 'l-table');
  util.extend('lego-core-dropdown', legoDropdownCheckExtend, 'lego-dropdown-check-extend');
  /* * * * * Override Here * * * * */
  // override default value

  // override default value
  //util.extend('lego-table', legoTableExtend);

  // additional feature for lego-next added
  // util.extend('lego-search-item', legoSearchItemExtend);
  // // additional feature for lego-next added
  // util.extend('lego-form-item', legoFormItemExtend);

  // // override default value
  // util.extend('lego-date-picker', legoDatePickerExtend);

  // // new extended component 'lego-code-dropdown' from 'lego-dropdown
  // util.extend('lego-dropdown', legoCodeDropdown, 'lego-code-dropdown');

  // // make new wrapping component and register new one as same name. chane old one as original-lego-page
  // util.wrapping('lego-page', legoPageWrapping, 'lego-page', 'original-lego-page');

  // // new extended component 'original-lego-grid-page' from 'original-lego-page' ('original-lego-page' is 'lego-page')
  // util.extend('original-lego-page', legoGridPage, 'original-lego-grid-page');
  // // new extended component 'lego-grid-page' from 'lego-page' ('lego-page' is 'lego-page-wrapping')
  // util.extend('lego-page', legoGridPageWrapping, 'lego-grid-page');
  // // util.extend('lego-page', legoGridPageWrapping);

  // util.extend('lego-form-box', legoFormBoxExtend);
  // util.extend('lego-dropdown', legoDropdownExtend);
  // util.extend('lego-modal', legoModalExtend);

  // util.extend('lego-text-field', legoTextFieldExtend);
  // // 이 아래로는 삭제예정
  // util.wrapping('lego-search-box', legoSearchBoxWrapping, 'lego-search-box', 'l-search-box'); // lego-component 형상에서 처리
  // util.extend('lego-segment-wrapper', legoSegmentExtend, 'lego-segment'); // lego-segment -> lego-segment-wrapper 변경
  // util.extend('lego-pagination', legoPaginationExtend); // lego-component 형상에서 처리
  /* * * * * * * * * * * * * * * * */

  /*********************************
     /* DESCRIPTION                   *
     /*********************************
     *   util.extend (
     *     arg1: extend 할 lego-component 이름.
     *     arg2: 추가하거나 덮어쓸 Vue script. 동작방식은 Vue 공식지원기능인 mixins 또는 extends와 동일합니다.
     *   )
     *   extend 이후 사용은 그대로 lego-component 형식으로 사용하면 됩니다.
     *
     *   util.wrapping (
     *     arg1: wrapping 할 lego-component 이름.
     *     arg2: wrapping 컴포넌트 실제 구현부. <template> 영역에서는 기존 lego-component 를 arg4의 이름으로 사용해야합니다.
     *     arg3: wrapping 된 새 컴포넌트의 이름
     *     arg4: 기존 lego-component 의 변경될 이름. arg2의 <template> 영역에는 arg4의 이름으로 기존 컴포넌트가 호출되어야합니다.
     *   )
     *   arg3과 arg4의 이름을 다르게 주는편이 좋습니다.
     *   arg3과 arg4를 동일 이름으로 주면 기존 lego-component 는 더이상 사용하지 못하고 새로 wrapping 된 컴포넌트만 사용가능합니다.
     *   동작에도 문제는 없으나 webpack-dev-server 의 hot-module replacement 기능 사용 시 일시적으로 무한루프에 빠질 수 있습니다.
     */
}
